import {
  ON_START_AKTIVITET_DELK,ON_AKTIVITET_DELK,ON_ERROR_AKTIVITET_DELK,
  ON_START_UPDATE_DATE_AKTIVITET, ON_UPDATE_DATE_AKTIVITETS, ON_ERROR_UPDATE_DATE_AKTIVITET,
  ON_START_GET_AKTIVITETER_USER_NEW,ON_GET_AKTIVITETER_USER_NEW,ON_GET_AKTIVITETER_USER_BUFFER,
    ON_START_NEW_AKTIVITET,
    ON_NEW_AKTIVITET,ON_GET_ANTAL_AKTIVITETER_AVTAL,
    ON_ERROR_NEW_AKTIVITET,
    ON_START_GET_AKTIVITETER_ORGNR,
    ON_GET_AKTIVITETER_ORGNR,
    ON_ERROR_GET_AKTIVITETER_ORGNR,
    ON_START_GET_AKTIVITETER_AVTAL,
    ON_GET_AKTIVITETER_AVTAL,
    ON_ERROR_GET_AKTIVITETER_AVTAL,
    ON_START_GET_AKTIVITETER_ARENDE,
    ON_ERROR_GET_AKTIVITETER_ARENDE,
    ON_GET_AKTIVITETER_ARENDE,
    ON_GET_ANTAL_AKTIVITETER_ARENDE,
    ON_START_GET_AKTIVITETER_USER,
    ON_GET_AKTIVITETER_USER,
    ON_ERROR_GET_AKTIVITETER_USER,
    ON_START_UPDATE_AKTIVITET,
    ON_UPDATE_AKTIVITET,
    ON_ERROR_UPDATE_AKTIVITET,
    ON_UPDATE_AKTIVITETS,
    ON_START_GET_AKTIVITETET,
    ON_GET_AKTIVITETET,
    ON_ERROR_GET_AKTIVITETET,
    ON_UPDATE_T_AKTIVITET,
    ON_ERROR_UPDATE_T_AKTIVITET,
    ON_START_AKTIVITET_NEWK,
    ON_AKTIVITET_NEWK,
    ON_ERROR_AKTIVITET_NEWK,
    ON_RESET_AKTIVITET_MESSAGE,
    ON_START_GET_AKTIVITETER_USER_TAGS,
    ON_GET_AKTIVETETER_STATS,
    ON_ERROR_GET_AKTIVETETER_STATS,
    ON_START_GET_AKTIVETETER_STATS,
    ON_SET_NUMAKTIVITETER_KUND,
    ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,ON_DELETE_AKTIVITET,
    FETCH_START_SET_UNAUTHE
} from "../constants/ActionTypes";
import { history } from "store";
import axios from 'util/Api' 
import { isEmpty,isUndefined } from "lodash";
import {RefreshUserInterface, getMoteByUserIDByDate} from 'actions'
import 'moment/locale/sv';
import moment from "moment/moment";
import { translate } from "../util/intlHelper";
import {encrypt,decrypt} from 'actions'

const getClientIp = async () => {
  let Ipadress='0.0.0.0'
       return Ipadress
}
//createNewAktivitet
export const createNewAktivitet = (userid,Afid,nAktivitet,page,Status,isFrom) =>{
    let IsFrom = isUndefined(isFrom)?0:isFrom
    const jwt =  JSON.parse(localStorage.token);
     return  async (dispatch) => {
      const ipAdress='0.0.0.0'
       dispatch({type: ON_START_NEW_AKTIVITET});
       dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Create.Activity")});
      //ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,
       axios.put('kontos/Aktivitet/new', {
        body: encrypt(JSON.stringify({
            Aktivitet:nAktivitet,
            Afid:Afid,
            userid:userid,
            Status:Status,
            ipAdress:ipAdress,
            Page:page,
            IsFrom: IsFrom
        }))},
        {headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then( data => {
        console.log("createNewAktivitet: ", data);
        if(data.data.success){
           let endata = decrypt(data.data.encryptedData,data.data.iv)
           console.log("createNewAktivitet1: ", endata);
           let ndate = JSON.parse(endata)
           dispatch({type: ON_NEW_AKTIVITET, payload: ndate.results});
           dispatch({type: ON_MESSAGE_KUND,payload:ndate.results.message});
           if(parseInt(IsFrom) === 4){
            //Ärende
            let Aid =nAktivitet.Aid
            dispatch(getArendeAktivtet(Afid,userid,Aid))
          }
          if(parseInt(IsFrom) === 3){
            //Kalender
            const today = moment(new Date());
            let startOFthesweek = today.startOf('week').format("YYYY-MM-DD");
            let  EndOFthesweek= today.endOf('week').format("YYYY-MM-DD");
            dispatch(getMoteByUserIDByDate(Afid,userid,[],startOFthesweek,EndOFthesweek)    )
            //getAvtalAktivtet = (Afid,userid,Avtal)
          }
          if(parseInt(IsFrom) === 2){
            //Avtal
            let Avtal =nAktivitet.Avtal
            dispatch(getAvtalAktivtet(Afid,userid,Avtal))
          }
          if(parseInt(IsFrom) === 1){
            //Kund
            let Orgnr =nAktivitet.Kund.Orgnr
            dispatch(getAktiviteterByOrgnr(userid,Afid,Orgnr,0))
            dispatch({type: ON_SET_NUMAKTIVITETER_KUND, payload: ndate.results})
          }		
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("createNewAktivitet2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_NEW_AKTIVITET, payload: ndate.error});
          dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Create.Activity")});
        }
        dispatch(getAktivitetTagsByUserID(userid,Afid))
        let AktiviterFilter =isUndefined(localStorage.AktiviterFilter)?[]:JSON.parse(localStorage.AktiviterFilter)
        dispatch(getAktivitetByUserID1(userid,Afid,AktiviterFilter))
        
       }).catch(function (error) {
        let errorMessage = translate("Error.Unknown");

        if (error.response) {
          // Server-side error handling
          switch (error.response.status) {
            case 400:
              errorMessage = translate("Error.BadRequest");
              break;
            case 401:
              errorMessage = translate("Error.Unauthorized");
              dispatch({ type: FETCH_START_SET_UNAUTHE });
              break;
            case 404:
              errorMessage = translate("Error.NotFound");
              break;
            case 500:
              errorMessage = translate("Error.Server");
              break;
            default:
              errorMessage = translate("Error.Generic")
          }
        } else if (error.message === "Network Error") {
          errorMessage = translate("Error.Network")
        }

        dispatch({ type: ON_ERROR_NEW_AKTIVITET, payload: errorMessage });
         
       });
     }
   } 



//getAktiviteterByOrgnr
export const getAktiviteterByOrgnr = (userid,Afid,Orgnr,page,searchWord) =>{
  let Page= isUndefined(page)?0:page
  let SearchWord= isUndefined(searchWord)?"":searchWord
  const jwt =  JSON.parse(localStorage.token);
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AKTIVITETER_ORGNR});
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.fetching.Activity")});
    //ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,
    axios.get('kontos/Aktivitet/getByOrgnr',
    { params:encrypt(JSON.stringify({Orgnr:Orgnr,Afid:Afid,userid:userid,page:Page,SearchWord,ipAdress:ipAdress})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log("getAktiviteterByOrgnr: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
           console.log("getAktiviteterByOrgnr1: ", endata);
           let ndate = JSON.parse(endata)
           dispatch({type: ON_GET_AKTIVITETER_ORGNR, payload: ndate.results});
         dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.fetch.Activity")});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAktiviteterByOrgnr2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_AKTIVITETER_ORGNR, payload: ndate.error});
        dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Fetch.Activity")});
      }

       dispatch(RefreshUserInterface(userid))
       dispatch(getAktivitetTagsByUserID(userid,Afid))
       
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AKTIVITETER_ORGNR, payload: error.message});
       let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }

       dispatch({ type: ON_ERROR_MESSAGE_KUND, payload: errorMessage });
       /*dispatch({type: ON_ERROR_MESSAGE_KUND, payload: "Error 1001: fel i server"});
         if(!isUndefined(error.response.status)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } */
     });
  }
}
//getAvtalAktivtet
export const getAvtalAktivtet = (Afid,userid,Avtal,isFrom=0) =>{
  const jwt =  JSON.parse(localStorage.token);
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AKTIVITETER_AVTAL});
    axios.get('kontos/Aktivitet/getByAvtal',
    { params:encrypt(JSON.stringify({Avtal:Avtal,Afid:Afid,userid:userid,ipAdress:ipAdress,isFrom})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getAvtalAktivtet: ", data);
        if (data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAvtalAktivtet1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_GET_AKTIVITETER_AVTAL, payload: ndate.results});
          dispatch({type: ON_GET_ANTAL_AKTIVITETER_AVTAL, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAvtalAktivtet3: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_GET_AKTIVITETER_AVTAL, payload: ndate.error});
        }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }

       dispatch({type: ON_ERROR_GET_AKTIVITETER_AVTAL, payload: errorMessage});
     });
  }
}
// ON_START_GET_AKTIVITETER_ARENDE,
// ON_GET_AKTIVITETER_ARENDE,
// ON_ERROR_GET_AKTIVITETER_ARENDE,
export const getArendeAktivtet = (Afid,userid,Aid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AKTIVITETER_ARENDE});
    axios.get('kontos/Aktivitet/getByArende',
    { params:encrypt(JSON.stringify({Aid:Aid,Afid:Afid,userid:userid,ipAdress:ipAdress})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data  => {
      console.log("getArendeAktivtet: ", data);
        if (data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getArendeAktivtet1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_GET_AKTIVITETER_ARENDE, payload: ndate.results});
          dispatch({type: ON_GET_ANTAL_AKTIVITETER_ARENDE, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getArendeAktivtet2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_GET_AKTIVITETER_ARENDE, payload: ndate.error});
        }
       
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AKTIVITETER_ARENDE, payload: errorMessage});
       
     });
  }
}
//getAktivitetByUserID1
export const getAktivitetByUserID1 = (mainUser,Afid, Filterstate,status) =>{
  const jwt =  JSON.parse(localStorage.token);
  let Status = isUndefined(status)?0:status
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AKTIVITETER_USER_NEW});
    axios.get('kontos/Aktivitet/getByUser',
    { params:encrypt(JSON.stringify({Afid:Afid,Filterstate:Filterstate,mainUser:mainUser,ipAdress:ipAdress,Status})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getAktivitetByUserID: ", data);
        if (data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAktivitetByUserID1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_GET_AKTIVITETER_USER_NEW, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAktivitetByUserID2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_GET_AKTIVITETER_USER, payload: ndate.error});
        }
      
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AKTIVITETER_USER, payload:errorMessage});
     });
  }
}

//getAktivitetByUserID
export const getAktivitetByUserID = (mainUser,Afid, Filterstate,status,keyword,searchTextd,page, Buffer = 0) =>{
  const jwt =  JSON.parse(localStorage.token);
  let Status = isUndefined(status)?0:status
  let Keyword = isUndefined(keyword)?"":keyword
  let Page = isUndefined(page)?0:page
  let searchText = isUndefined(searchTextd)?"":searchTextd
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch(getAktivitetTagsByUserID(mainUser,Afid))
    dispatch({type: ON_START_GET_AKTIVITETER_USER, payload: {Buffer}});
    axios.get('kontos/Aktivitet/getByUser',
    { params:encrypt(JSON.stringify({Afid:Afid,Filterstate:Filterstate,mainUser:mainUser,Status:Status,Keyword:Keyword,
      searchText:searchText,page:Page,ipAdress:ipAdress})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getAktivitetByUserID: ", data);
        if (data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAktivitetByUserID1: ", endata);
          let ndate = JSON.parse(endata)
          if(parseInt(Buffer) === 1) dispatch({type: ON_GET_AKTIVITETER_USER_BUFFER, payload: ndate.results});
          else dispatch({type: ON_GET_AKTIVITETER_USER, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAktivitetByUserID2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_GET_AKTIVITETER_USER, payload: ndate.error});
        }
       
       dispatch(RefreshUserInterface(mainUser))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AKTIVITETER_USER, payload: errorMessage});
       
     });
  }
}
export const getAktivitetStatsUserID = (mainUser,Afid, Filterstate,status,Keyword) =>{
  const jwt =  JSON.parse(localStorage.token);
  let Status = isUndefined(status)?0:status
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch(getAktivitetTagsByUserID(mainUser,Afid))
    dispatch({type: ON_START_GET_AKTIVETETER_STATS});
    axios.get('kontos/Aktivitet/getByUserStats',
    { params:encrypt(JSON.stringify({Afid:Afid,Filterstate:Filterstate,mainUser:mainUser,Status:Status,Keyword, 
      ipAdress:ipAdress})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getAktivitetStatsUserID: ", data);
      if( data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAvtalAktivtet1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_GET_AKTIVETETER_STATS, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAvtalAktivtet3: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_AKTIVETETER_STATS, payload: ndate.error});
      }
       dispatch(RefreshUserInterface(mainUser))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AKTIVETETER_STATS, payload: errorMessage});
        
     });
  }
}
export const getAktivitetTagsByUserID = (Userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  console.log(Userid)
  console.log(Afid)
  
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    axios.get('kontos/Aktivitet/tags/get',
    { params:encrypt(JSON.stringify({Userid,Afid,ipAdress:ipAdress})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data  => {
      console.log("getTags: ", data);
        if (data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getTags1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_START_GET_AKTIVITETER_USER_TAGS, payload: ndate.results});
        }
      
    //   //dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
         if(!isUndefined(error.response.status)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       
     });
  }
}
//CreateAktivitetTag
export const CreateAktivitetTag = (Afid,userid,Label) =>{
  const jwt =  JSON.parse(localStorage.token);
  
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    axios.put('kontos/Aktivitet/tags/new',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      Label:Label,
      ipAdress:ipAdress,
    }))},{ 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("updateTags: ", data);
      //dispatch(RefreshUserInterface(userid))
       dispatch(getAktivitetTagsByUserID(userid,Afid))
       
     }).catch(function (error) {
         if(!isUndefined(error.response.status)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       }        
     });
  }
}
//
export const updateAktivitetTag = (data, Userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    axios.put('kontos/Aktivitet/tags/update',
    { params:encrypt(JSON.stringify({data, Userid,Afid,ipAdress:ipAdress}))},{  
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("updateTags: ", data);
      //dispatch(RefreshUserInterface(Userid))
       dispatch(getAktivitetTagsByUserID(Userid,Afid))
     }).catch(function (error) {
         if(!isUndefined(error.response.status)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       
     });
  }
}
export const deleteAktivitetTag = (id, Userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
     axios.delete('kontos/Aktivitet/tags/delete', {params: encrypt(JSON.stringify({id,Afid,Userid,ipAdress})),headers: { 'Authorization': `Bearer ${jwt}`}})
     .then(data => {
      //dispatch(RefreshUserInterface(Userid))
      // dispatch({type: OFFERTPREV_ON_GET_BILAGOR, payload: data})
      console.log("deleteTag: ", data);
      dispatch(getAktivitetTagsByUserID(Userid,Afid))
      
    }).catch(err => {
      console.log(err)
    })
  }
}
//setStartoItem
export const setStartoItem = (Afid,userid,todo) =>{
  const jwt =  JSON.parse(localStorage.token);
   return  async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_UPDATE_AKTIVITET});
     axios.put('kontos/Aktivitet/updateStToken', {
      body: encrypt(JSON.stringify({
          todo:todo,
          Afid:Afid,
          ipAdress:ipAdress,
          userid:userid
      }))},{ 
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("setStartoItem: ", data);
      if( data.data.success) {  
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("setStartoItem1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_AKTIVITET, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("setStartoItem2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_AKTIVITET, payload: ndate.error});
      }
      //dispatch(RefreshUserInterface(userid))
      
       
       let AktiviterFilter =isUndefined(localStorage.AktiviterFilter)?[]:JSON.parse(localStorage.AktiviterFilter)
       dispatch(getAktivitetByUserID1(userid,Afid,AktiviterFilter))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_UPDATE_AKTIVITET, payload:errorMessage});
     });
   }
 } 
//setStartoItems
export const setStartoItems = (Afid,userid,todo,value, Keyword, searchText) =>{
  const jwt =  JSON.parse(localStorage.token);
  let AktiviterFilter =isUndefined(localStorage.AktiviterFilter)?[]:JSON.parse(localStorage.AktiviterFilter)
   return  async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_UPDATE_AKTIVITET});
     if(parseInt(value) === 5) dispatch({type: ON_START_MESSAGE_KUND,
      payload: translate("Activity.Deleting", `Raderar ${todo.length}st aktiviteter`, { count: todo.length }),
    });
     if(parseInt(value) === 4) dispatch({type: ON_START_MESSAGE_KUND,
      payload: translate("Activity.Completing", `Klarmarkerar ${todo.length}st aktiviteter`, { count: todo.length }),
    });
     axios.put('kontos/Aktivitet/updateStTokens', {
      body: encrypt(JSON.stringify({
          todos:todo,
          value:value,
          Afid:Afid,
          ipAdress:ipAdress,
          userid:userid,
					Filterstate: AktiviterFilter,
					Keyword,
					searchText
      }))},{ 
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("setStartoItems: ", data);
      if( data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("setStartoItems1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_UPDATE_AKTIVITETS, payload: ndate.results});
          if(parseInt(value) === 5) dispatch({type: ON_DELETE_AKTIVITET,
            payload: translate("Activity.Deleted", `${todo.length}st aktiviteter raderade`, { count: todo.length }),
          });
           if(parseInt(value) === 4) dispatch({type: ON_MESSAGE_KUND,
            payload: translate("Activity.Completed", `${todo.length}st aktiviteter klarmarkerade`, { count: todo.length }),
          });
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAvtalAktivtet3: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_AKTIVITET, payload: ndate.error});
         dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Activity")});
      }
       
       //dispatch(RefreshUserInterface(userid))
      //  dispatch(getAktivitetByUserID1(userid,Afid,AktiviterFilter))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_UPDATE_AKTIVITET, payload: errorMessage});
     });
   }
 } 
//setNewAnsvarigtoItems
export const setNewAnsvarigtoItems = (Afid,userid,todo,Ansvarig, Status = 0, Keyword = '', searchText = '' ) =>{

  let AktiviterFilter =isUndefined(localStorage.AktiviterFilter)?[]:JSON.parse(localStorage.AktiviterFilter)
  const jwt =  JSON.parse(localStorage.token);
   return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_UPDATE_DATE_AKTIVITET});
     axios.put('kontos/Aktivitet/updateAnsvarigs', {
      body: encrypt(JSON.stringify({
          todos:todo,
          Ansvarig:Ansvarig,
          Afid:Afid,
          ipAdress:ipAdress,
          userid:userid,
					Filterstate:AktiviterFilter,
					Status, Keyword, searchText
      }))},{ 
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("setNewAnsvarigtoItems: ", data);
      if( data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAvtalAktivtet1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_DATE_AKTIVITETS, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAvtalAktivtet3: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UPDATE_DATE_AKTIVITET, payload: ndate.error});
      }
    
       //dispatch(RefreshUserInterface(userid))
      //  dispatch(getAktivitetByUserID1(userid,Afid,AktiviterFilter))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_UPDATE_DATE_AKTIVITET, payload: errorMessage});
     });
   }
 }
//setNewDatetoItems
export const setNewDatetoItems = (Afid,userid,todo,newDate, Status = 0, Keyword = '', searchText = '') =>{
  let AktiviterFilter =isUndefined(localStorage.AktiviterFilter)?[]:JSON.parse(localStorage.AktiviterFilter)
  const jwt =  JSON.parse(localStorage.token);
   return  async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_UPDATE_DATE_AKTIVITET});
     axios.put('kontos/Aktivitet/updateDates', {
      body: encrypt(JSON.stringify({
          todos:todo,
          newDate:newDate,
          Afid:Afid,
          ipAdress:ipAdress,
          userid:userid,
					Filterstate:AktiviterFilter,
					Status, Keyword, searchText
      }))},{ 
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("setStartoItems: ", data);
      if( data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAvtalAktivtet1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_DATE_AKTIVITETS, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAvtalAktivtet3: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_DATE_AKTIVITET, payload: ndate.error});
      }
     
       //dispatch(RefreshUserInterface(userid))
      //  dispatch(getAktivitetByUserID1(userid,Afid,AktiviterFilter))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

      if (error.response) {
        // Server-side error handling
        switch (error.response.status) {
          case 400:
            errorMessage = translate("Error.BadRequest");
            break;
          case 401:
            errorMessage = translate("Error.Unauthorized");
            dispatch({ type: FETCH_START_SET_UNAUTHE });
            break;
          case 404:
            errorMessage = translate("Error.NotFound")
            break;
          case 500:
            errorMessage = translate("Error.Server")
            break;
          default:
            errorMessage = translate("Error.Generic")
        }
      } else if (error.message === "Network Error") {
        errorMessage = translate("Error.Network") ;
      }
       dispatch({type: ON_ERROR_UPDATE_DATE_AKTIVITET, payload: errorMessage});
     });
   }
 } 
 
//updateAktiviteterLabel
export const updateAktiviteterLabel = (Afid,userid,todo,label, Status = 0, Keyword = '', searchText = '') =>{
  let AktiviterFilter =isUndefined(localStorage.AktiviterFilter)?[]:JSON.parse(localStorage.AktiviterFilter)
  const jwt =  JSON.parse(localStorage.token);
   return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    
     dispatch({type: ON_START_UPDATE_AKTIVITET});
     axios.put('kontos/Aktivitet/AddlabetsTokens', {
      body: encrypt(JSON.stringify({
          todos:todo,
          label:label,
          Afid:Afid,
          ipAdress:ipAdress,
          userid:userid,
					Status, 
					Keyword, 
					searchText,
					Filterstate:AktiviterFilter
      }))},{ 
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("updateAktiviteterLabel: ", data);
      if( data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_AKTIVITETS, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_AKTIVITET, payload: ndate.error});
      }
    
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

      if (error.response) {
        // Server-side error handling
        switch (error.response.status) {
          case 400:
            errorMessage = translate("Error.BadRequest");
            break;
          case 401:
            errorMessage = translate("Error.Unauthorized");
            dispatch({ type: FETCH_START_SET_UNAUTHE });
            break;
          case 404:
            errorMessage = translate("Error.NotFound")
            break;
          case 500:
            errorMessage = translate("Error.Server")
            break;
          default:
            errorMessage = translate("Error.Generic")
        }
      } else if (error.message === "Network Error") {
        errorMessage = translate("Error.Network") ;
      }
       dispatch({type: ON_ERROR_UPDATE_AKTIVITET, payload: errorMessage});
     });
   }
 } 
//getCurrentTodo
export const getCurrentTodo = (Afid, userid,TodoId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AKTIVITETET});
    axios.get('kontos/Aktivitet/getById',
    { params:encrypt(JSON.stringify({Afid:Afid,userid:userid,AktivitetId:TodoId,ipAdress:ipAdress})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getCurrentTodo: ", data);
      if( data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getCurrentTodo1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_AKTIVITETET, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getCurrentTodo2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_AKTIVITETET, payload: ndate.error});
      }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

      if (error.response) {
        // Server-side error handling
        switch (error.response.status) {
          case 400:
            errorMessage = translate("Error.BadRequest");
            break;
          case 401:
            errorMessage = translate("Error.Unauthorized");
            dispatch({ type: FETCH_START_SET_UNAUTHE });
            break;
          case 404:
            errorMessage = translate("Error.NotFound")
            break;
          case 500:
            errorMessage = translate("Error.Server")
            break;
          default:
            errorMessage = translate("Error.Generic")
        }
      } else if (error.message === "Network Error") {
        errorMessage = translate("Error.Network") ;
      }
       dispatch({type: ON_ERROR_GET_AKTIVITETET, payload: errorMessage});
     });
  }
}

//updateThisAktivitet
export const updateThisAktivitet = (userid,Afid,newState, status, keyword, searchTextd, IsFrom = 0) =>{
  const jwt =  JSON.parse(localStorage.token);
   return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    
     dispatch({type: ON_START_UPDATE_AKTIVITET});

     dispatch({type: ON_START_MESSAGE_KUND,
      payload: translate(
        newState.Status === 4
          ? "Action.Activity.Completing"
          : newState.Status === 5
          ? "Action.Activity.Deleting"
          : "Action.Activity.Saving",
        `${newState.Status === 4 ? "Klarmarkerar" : newState.Status === 5 ? "Raderar" : "Sparar"} aktivitet`
      ),
    });

     await axios.put('kontos/Aktivitet/Update', {
      body: encrypt(JSON.stringify({
          newState:newState,
          Afid:Afid,
          ipAdress:ipAdress,
          userid:userid
      }))},{ 
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data  => {
      console.log("updateThisAktivitet: ", data);
      if( data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAvtalAktivtet1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_T_AKTIVITET, payload: ndate.results});
				if(newState.Status !== 5) dispatch({type: ON_MESSAGE_KUND,
          payload:newState.Status === 4 ? translate("Action.Activity.Complete"):translate("Action.Activity.Saved")
        });
				if(newState.Status === 5) dispatch({type: ON_DELETE_AKTIVITET,
          payload:translate("Action.Activity.Deleted")
        });
        if(parseInt(IsFrom) === 4){
          //Ärende
          let Aid = ndate.results.currentAktivitet.Todo.Aid
          dispatch(getArendeAktivtet(Afid,userid,Aid))
        }
        if(parseInt(IsFrom) === 3){
          //Kalender
          const today = moment(new Date());
          let startOFthesweek = today.startOf('week').format("YYYY-MM-DD");
          let  EndOFthesweek= today.endOf('week').format("YYYY-MM-DD");
          dispatch(getMoteByUserIDByDate(Afid,userid,[],startOFthesweek,EndOFthesweek)    )
          //getAvtalAktivtet = (Afid,userid,Avtal)
        }
        if(parseInt(IsFrom) === 2){
          //Avtal
          //getAvtalAktivtet = (Afid,userid,Avtal)
          let Avtal = ndate.results.currentAktivitet.Todo.Avtalid
          dispatch(getAvtalAktivtet(Afid,userid,Avtal))
        }
        if(parseInt(IsFrom) === 1){
          //Kund
          let Orgnr = ndate.results.currentAktivitet.Todo.Orgnr
          dispatch(getAktiviteterByOrgnr(userid,Afid,Orgnr,0))
        }
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAvtalAktivtet3: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_T_AKTIVITET, payload: ndate.error});
				dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.1104")});
      }

		
       //dispatch(RefreshUserInterface(userid))
       dispatch(getAktivitetTagsByUserID(userid,Afid))
       
       let AktiviterFilter =isUndefined(localStorage.AktiviterFilter)?[]:JSON.parse(localStorage.AktiviterFilter)
       dispatch(getAktivitetByUserID(userid,Afid,AktiviterFilter, status, keyword, searchTextd))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

      if (error.response) {
        // Server-side error handling
        switch (error.response.status) {
          case 400:
            errorMessage = translate("Error.BadRequest");
            break;
          case 401:
            errorMessage = translate("Error.Unauthorized");
            dispatch({ type: FETCH_START_SET_UNAUTHE });
            break;
          case 404:
            errorMessage = translate("Error.NotFound")
            break;
          case 500:
            errorMessage = translate("Error.Server")
            break;
          default:
            errorMessage = translate("Error.Generic")
        }
      } else if (error.message === "Network Error") {
        errorMessage = translate("Error.Network") ;
      }
       dispatch({type: ON_ERROR_UPDATE_T_AKTIVITET, payload: errorMessage});
     });
   }
 } 
//onEditMessage
export const onEditMessage = (userid,Afid,Task,message, Mentions = []) =>{
  const jwt =  JSON.parse(localStorage.token);
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_AKTIVITET_NEWK});
    axios.put('kontos/Aktivitet/editKommentar', {
      body: encrypt(JSON.stringify({
          message:message,
          Task:Task,
          ipAdress:ipAdress,
          Afid:Afid,
          Mentions:Mentions,
          userid:userid
      }))},{ 
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("onEditMessage: ", data);
      if( data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("onEditMessage1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_AKTIVITET_NEWK, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("onEditMessage2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_AKTIVITET_NEWK, payload: ndate.error});
      }
        //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

      if (error.response) {
        // Server-side error handling
        switch (error.response.status) {
          case 400:
            errorMessage = translate("Error.BadRequest");
            break;
          case 401:
            errorMessage = translate("Error.Unauthorized");
            dispatch({ type: FETCH_START_SET_UNAUTHE });
            break;
          case 404:
            errorMessage = translate("Error.NotFound")
            break;
          case 500:
            errorMessage = translate("Error.Server")
            break;
          default:
            errorMessage = translate("Error.Generic")
        }
      } else if (error.message === "Network Error") {
        errorMessage = translate("Error.Network") ;
      }
       dispatch({type: ON_ERROR_AKTIVITET_NEWK, payload: errorMessage});
         
     });
  }
}
//submitMessage
export const submitMessage = (userid,Afid,AktivitetId,message,Utfall, Mentions = []) =>{
  const jwt =  JSON.parse(localStorage.token);
   return  async (dispatch) => {
   
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_AKTIVITET_NEWK});
     axios.put('kontos/Aktivitet/newKommentar', {
      body: encrypt(JSON.stringify({
          AktivitetId:AktivitetId,
          message:message,
          Utfall:Utfall,
          ipAdress:ipAdress,
          Afid:Afid,
          Mentions:Mentions,
          userid:userid
      }))},{ 
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("submitMessage: ", data);
      if( data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("submitMessage1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_AKTIVITET_NEWK, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("submitMessage2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_AKTIVITET_NEWK, payload: ndate.error});
      }
      
        //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

      if (error.response) {
        // Server-side error handling
        switch (error.response.status) {
          case 400:
            errorMessage = translate("Error.BadRequest");
            break;
          case 401:
            errorMessage = translate("Error.Unauthorized");
            dispatch({ type: FETCH_START_SET_UNAUTHE });
            break;
          case 404:
            errorMessage = translate("Error.NotFound")
            break;
          case 500:
            errorMessage = translate("Error.Server")
            break;
          default:
            errorMessage = translate("Error.Generic")
        }
      } else if (error.message === "Network Error") {
        errorMessage = translate("Error.Network") ;
      }
       dispatch({type: ON_ERROR_AKTIVITET_NEWK, payload: errorMessage});
     });
   }
 } 
//DeleteMessage
export const DeleteMessage = (userid,Afid,AktivitetId,delItem) =>{
  const jwt =  JSON.parse(localStorage.token);
   return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_AKTIVITET_DELK});
     axios.put('kontos/Aktivitet/DelKommentar', {
      body: encrypt(JSON.stringify({
          AktivitetId:AktivitetId,
          delItem:delItem,
          Afid:Afid,
          ipAdress:ipAdress,
          userid:userid
      }))},{ 
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("DeleteMessage: ", data);
      if( data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("DeleteMessage1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_AKTIVITET_DELK, payload: ndate.results});
      }else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("DeleteMessage2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_AKTIVITET_DELK, payload: ndate.error});
      }

   
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

      if (error.response) {
        // Server-side error handling
        switch (error.response.status) {
          case 400:
            errorMessage = translate("Error.BadRequest");
            break;
          case 401:
            errorMessage = translate("Error.Unauthorized");
            dispatch({ type: FETCH_START_SET_UNAUTHE });
            break;
          case 404:
            errorMessage = translate("Error.NotFound")
            break;
          case 500:
            errorMessage = translate("Error.Server")
            break;
          default:
            errorMessage = translate("Error.Generic")
        }
      } else if (error.message === "Network Error") {
        errorMessage = translate("Error.Network") ;
      }

       dispatch({type: ON_ERROR_AKTIVITET_DELK, payload: errorMessage});
     });
   }
 } 
export const resetAktiviteMessage=()=>{
  return  async (dispatch) => {
    dispatch({type: ON_RESET_AKTIVITET_MESSAGE});
  }
}
